import React, {useCallback, useLayoutEffect} from 'react'

import {PageContentInterface} from "../page-content-interface"
import AttachmentsCollection from "../../../../../core/model2/attachment/attachments"
import PageControls from "../controls/controls"
import {useForceUpdate} from "../../../../../core/gd/utils/dom-and-react/react-utils"
import HeaderAppTitleNew from "../../../../../layout/top/header/common/app-title/app-title-new"
import ApiDocument from "../../../../../core/gd/api/document"
import UserIcon from "../../../../../core/gd-components/icons/user/user"
import formatDate from "../../../../../core/gd/format/date"

type Props = {
    className?      : string

    app             : PageContentInterface
    pageId          : ID
    attachments?    : AttachmentsCollection
}

export const PAGE_NAME_CHANGED = 'page:name-changed'

export default function PageTitle(props: Props) {

    const titleStyle : style = {
        marginLeft  : '12px',
    }

    const forceUpdate = useForceUpdate()

    useLayoutEffect(() => {
        return gd.bus.subscribeNoContext(PAGE_NAME_CHANGED, onNameChanged)
    }, [props.app.document])

    const onNameChanged = useCallback((name: string) => {
        props.app.document.name = name
        forceUpdate()
    }, [])

    const onChange = (title: string) => {
        if (props.app.document.pages.length > 1) {
            const page = props.app.document.pages.getPage(props.pageId)!
            page.title = title
            props.app.document.save()
            props.app.reRender()
        } else {
            props.app.document.name = title
            ApiDocument.update(props.app.document.id, {name: title})
        }

        forceUpdate()
    }

    const getName = () => {
        if (props.app.document.pages.length > 1) {
            return props.app.document.pages.getPage(props.pageId)?.title!
        } else {
            return props.app.document.name
        }
    }

    const canEdit       = !gd.isSharedView && props.app.project.acl.hasFullAccess
    const showControls  = !gd.isSharedView && !props.app.editorLocalSettings.showControls

    const createdByUser     = props.app.settings?.showCreatedBy ? props.app.document.createdByUser : null
    const lastUpdatedByUser = props.app.settings?.showLastUpdatedBy ? props.app.document.lastUpdatedByUser : null

    const hasCover = !!props.app.document?.cover
    const showUsers         = createdByUser || lastUpdatedByUser

    const classes = Classes("page-title-container ", props.className, {
        'p-t-70'        : !hasCover,
        'p-t-20'        : hasCover
    })

    return (
        <div className={classes}>
            {showControls &&
                <PageControls app           = {props.app}
                              attachments   = {props.attachments}/>}

            <div className="page-title flex-row-left-center">
                <HeaderAppTitleNew style    = {titleStyle}
                                   name     = {getName()}
                                   maxWidth = {600}
                                   editable = {canEdit}
                                   onChange = {onChange}/>
            </div>

            {showUsers &&
                <div className="page-users flex-row-left-center m-t-5">
                    {createdByUser &&
                        <div className="flex-row-left-center m-r-20">
                            <div className="ui5-txt-not-important-small m-r-8">Created by:</div>
                            <UserIcon className = "m-r-8"
                                      size      = "22"
                                      userId    = {createdByUser.id}/>
                            <div className="ui5-txt-less-important">{"{0} ({1})".f(createdByUser.name, formatDate(props.app.document.momentCreated!, 'MMM D'))}</div>
                        </div>}

                    {lastUpdatedByUser &&
                        <div className="flex-row-left-center m-r-20">
                            <div className="ui5-txt-not-important-small m-r-8">Last updated by:</div>
                            <UserIcon className = "m-r-8"
                                      size      = "22"
                                      userId    = {lastUpdatedByUser.id}/>
                            <div className="ui5-txt-less-important">{"{0} ({1})".f(lastUpdatedByUser.name, formatDate(props.app.document.lastUpdated!, 'MMM D'))}</div>
                        </div>}
                </div>}
        </div>
    )
}
